import * as Scrivito from "scrivito";

Scrivito.provideWidgetClass("VideoWidget", {
  attributes: {
    video: ["reference", { only: "Video" }],
    captionTrack: "reference",
    descriptionTrack: "reference",
    poster: ["reference", { only: "Image" }],
    ariaLabel: "string",
    autoplay: "boolean",
    loop: "boolean",
    muted: "boolean",
  },
});
